import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { scroller } from 'react-scroll'

import EditorMain from '../Editor/Editor.js'

import { IconInfo } from '../../svg'

import AssetManager from '../../common/components/AssetManager/AssetManager'
import Modal from './'
import Toast from '../../common/components/Toast/Toast'

import { capitalize_first_letter } from '../../utils/formatter'

class ShareProjectOptions extends React.Component {
    _isMounted = false

    constructor(props) {
        super(props)
        this.state = {
            ready_show: false,

            entities: [],

            redirect: '',

            og_info: {
                title: '',
                description: '',
                image_id: null,
                image_url: null,
                custom_image: null,
            },

            saving_process: false,

            asset_manager_modal: {
                is_open: false,
                active_item_index: null,
            },

            main_image_canvas: null,
        }
        this.base_state = this.state
    }

    async componentDidMount() {
        this._isMounted = true

        const {
            data: { og_info, main_image_canvas, share_entities },
            t,
        } = this.props

        let format_entities = []

        const entities = Object.entries(share_entities.entities)
        for (const [index, [key, value]] of Object.entries(entities)) {
            const parsed_index = parseInt(index)

            const _image_canvas = !value.customImage ? await EditorMain.getHtmlPreview(value.previewHtml) : null

            let name = t('_common.screen')
            const tags_arr = value.screen.tags.split(' ')
            if (tags_arr.length > 1) {
                name = capitalize_first_letter(tags_arr[1]) + `${entities.length > 1 ? ` ${parsed_index + 1}` : ''}`
            }

            format_entities.push({
                key,
                index: parsed_index,
                name,

                content: {
                    _image_canvas,
                    _image_canvas_loading: false,
                    _image_canvas_data: _image_canvas ? _image_canvas.toDataURL('image/png', 0.95) : null,

                    screen: {
                        id: value.screen.id,
                        tags: value.screen.tags,
                    },
                    component_id: value.componentId,
                    title: value.title,
                    description: value.description,
                    image_id: value.imageId.length ? value.imageId : null,
                    image_url: value.imageUrl.length ? value.imageUrl : null,
                    custom_image: value.customImage,
                    preview_html: value.previewHtml,
                    link: value.href,
                },
            })
        }

        const redirect = EditorMain.getSharingLinkRedirectUrl() || ''

        await this.setState({
            entities: format_entities,
            redirect,
            og_info,
            main_image_canvas,
            ready_show: true,
        })
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    handleClick__save = async evt => {
        evt.preventDefault()

        const { events } = this.props
        const { entities, og_info, redirect } = this.state

        try {
            await this.setState({
                saving_process: true,
            })

            const reformat_entities = entities.reduce((acc, item) => {
                acc[item.key] = {
                    screen: {
                        id: item.content.screen.id,
                        tags: item.content.screen.tags,
                    },
                    componentId: item.content.component_id,
                    title: item.content.title ? item.content.title : '',
                    description: item.content.description ? item.content.description : '',
                    imageId: item.content.custom_image ? item.content.image_id : '',
                    imageUrl: item.content.custom_image ? item.content.image_url : '',
                    customImage: item.content.custom_image,
                    previewHtml: item.content.preview_html,
                    href: item.content.link,
                }
                return acc
            }, {})

            await EditorMain.setEditedAppShareEntities({ entities: reformat_entities })

            if (og_info.image_id !== '') {
                await EditorMain.setEditedProjectPreviewImage(og_info.image_id)
            }

            if (typeof redirect === 'string') {
                EditorMain.setSharingLinkRedirectUrl(redirect.length ? redirect : null)
            }

            events.change_og_info(og_info)

            await events.init_save_silent()

            events.on_close()

            Toast('success', {
                title: this.props.t('_common.saved'),
                time: 2000,
            })
        } catch (err) {
            console.error(err)
            Toast('error', {})
        } finally {
            if (this._isMounted) {
                await this.setState({
                    saving_process: false,
                })
            }
        }
    }

    handleChange__input = (index, target) => async evt => {
        evt.preventDefault()
        try {
            if (index !== null) {
                let { entities } = this.state

                entities[index].content[target] = evt.target.value

                await this.setState({
                    entities,
                })
            } else {
                let { og_info } = this.state

                og_info[target] = evt.target.value

                await this.setState({
                    og_info,
                })
            }
        } catch (err) {
            console.error(err)
        }
    }

    onExited = async () => {
        await this.setState({
            entities: [],
        })
    }

    scrollTo = target => () => {
        scroller.scrollTo(target, {
            containerId: 'scroll-container-1',
            smooth: true,
            duration: 400,
        })
    }

    handleClick__open_asset_manager_modal = active_item_index => evt => {
        evt.preventDefault()

        this.setState(prevState => ({
            asset_manager_modal: {
                ...prevState.asset_manager_modal,
                is_open: true,
                active_item_index,
            },
        }))
    }
    handleClick__close_asset_manager_modal = () => {
        this.setState(prevState => ({
            asset_manager_modal: {
                ...prevState.asset_manager_modal,
                is_open: false,
            },
        }))
    }

    handleClick__place_image = async value => {
        const {
            asset_manager_modal: { active_item_index },
        } = this.state

        if (active_item_index !== null) {
            let { entities } = this.state

            entities[active_item_index].content.image_id = value.id
            entities[active_item_index].content.image_url = value.src
            entities[active_item_index].content.custom_image = true

            await this.setState({
                entities,
            })
        } else {
            let { og_info } = this.state

            og_info.image_id = value.id
            og_info.image_url = value.src
            og_info.custom_image = true

            await this.setState({
                og_info,
            })
        }
    }
    handleClick__restore_image = (target, index) => async () => {
        try {
            switch (target) {
                case 'entities': {
                    let { entities } = this.state

                    if (!entities[index].content._image_canvas) {
                        entities[index].content._image_canvas_loading = true
                        await this.setState({
                            entities,
                        })
                        const cvs = await EditorMain.getHtmlPreview(entities[index].content.preview_html)
                        entities[index].content._image_canvas = cvs
                        entities[index].content._image_canvas_data = cvs.toDataURL('image/png', 0.95)
                        entities[index].content._image_canvas_loading = false
                        await this.setState({
                            entities,
                        })
                    }

                    entities[index].content.image_id = null
                    entities[index].content.image_url = null
                    entities[index].content.custom_image = false

                    await this.setState({
                        entities,
                    })
                    break
                }
                case 'og_info': {
                    let { og_info } = this.state

                    og_info.image_id = ''
                    og_info.image_url = ''
                    og_info.custom_image = false

                    await this.setState({
                        og_info,
                    })
                    break
                }
                default:
                    break
            }
        } catch (err) {
            console.error(err)
        }
    }

    render() {
        const {
            og_info,
            entities,
            redirect,
            asset_manager_modal,
            saving_process,
            main_image_canvas,
            ready_show,
        } = this.state
        const {
            is_open,
            classes,
            overlay_close,
            settings,
            events,
            data: { project },
            t,
        } = this.props

        // const ASSET_MANAGER_SORT =
        //     asset_manager_modal.active_item_index !== null
        //         ? [SORT_TAB_ALL, SORT_TAB_THIS_PROJECT]
        //         : [SORT_TAB_THIS_PROJECT]

        return ready_show ? (
            <>
                <Modal
                    settings={{ overlay_close: overlay_close }}
                    classes={classes}
                    data={{ open: is_open, max_width: settings.max_width }}
                    events={{ onCloseModal: events.on_close, onExited: this.onExited }}
                >
                    <div className="head head-v1">{t('_components._modal._share_project_options.title')}</div>
                    <div className="wrap">
                        {entities.length ? (
                            <aside>
                                <ul>
                                    <li
                                        key="project-link-preview"
                                        onClick={this.scrollTo(`scroll-element--project-link-preview`)}
                                    >
                                        {t('_components._modal._share_project_options.main_share_settings')}
                                    </li>
                                    {entities.map(item => {
                                        return (
                                            <li
                                                key={item.index}
                                                onClick={this.scrollTo(`scroll-element-${item.index}`)}
                                            >
                                                {item.name}
                                            </li>
                                        )
                                    })}
                                </ul>
                            </aside>
                        ) : null}
                        <div className={`body${entities.length ? ' with-menu' : ''}`}>
                            <ul className="blocks-options" id="scroll-container-1">
                                <li key="project-link-preview" id={`scroll-element--project-link-preview`}>
                                    <div className="title">
                                        {t('_components._modal._share_project_options.main_share_settings')}
                                    </div>
                                    <div className="box">
                                        <div className="preview-block">
                                            <div className="window">
                                                <div
                                                    className="image"
                                                    style={{
                                                        backgroundImage: `${
                                                            og_info.custom_image
                                                                ? `url(${og_info.image_url})`
                                                                : `url(${main_image_canvas.toDataURL(
                                                                      'image/png',
                                                                      0.95,
                                                                  )})`
                                                        }`,
                                                    }}
                                                ></div>
                                                <div className="text">
                                                    <div
                                                        className={`title${
                                                            !og_info.title.length ? ' title-empty' : ''
                                                        }`}
                                                    >
                                                        {og_info.title}
                                                    </div>
                                                    <div
                                                        className={`description${
                                                            !og_info.description.length ? ' description-empty' : ''
                                                        }`}
                                                    >
                                                        {og_info.description}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="upload">
                                                <button
                                                    className="button"
                                                    data-size="md"
                                                    data-variant="primary"
                                                    onClick={this.handleClick__open_asset_manager_modal(null)}
                                                >
                                                    {t('_components._modal._share_project_options.change_image')}
                                                </button>
                                                {og_info.custom_image ? (
                                                    <p onClick={this.handleClick__restore_image('og_info', null)}>
                                                        {t('_components._modal._share_project_options.restore_image')}
                                                    </p>
                                                ) : null}
                                            </div>
                                            <div className="note">
                                                {t('_components._modal._share_project_options.recommended_resolution')}
                                                <br />
                                                {t('_components._modal._share_project_options.up_to_10_mb')}
                                            </div>
                                        </div>
                                        <div className="info-block">
                                            <ul className="inputs-block">
                                                <li>
                                                    <div className="title">
                                                        {t('_common.title')}
                                                        <span>{og_info.title.length}/40</span>
                                                    </div>
                                                    <div className="input-box">
                                                        <input
                                                            autoComplete="off"
                                                            maxLength={40}
                                                            type="text"
                                                            value={og_info.title}
                                                            onChange={this.handleChange__input(null, 'title')}
                                                        />
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="title">
                                                        {t('_common.description')}
                                                        <span>{og_info.description.length}/100</span>
                                                    </div>
                                                    <div className="textarea-box">
                                                        <textarea
                                                            rows="3"
                                                            value={og_info.description}
                                                            maxLength={100}
                                                            onChange={this.handleChange__input(null, 'description')}
                                                        ></textarea>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="title">
                                                        {t('_components._modal._share_project_options.redirect_to_web')}
                                                    </div>
                                                    <div className="input-box">
                                                        <input
                                                            autoComplete="off"
                                                            maxLength={512}
                                                            type="text"
                                                            value={redirect}
                                                            onChange={event => {
                                                                this.setState({
                                                                    ...this.state,
                                                                    redirect: event.target.value,
                                                                })
                                                            }}
                                                        />
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                                {entities.map(item => {
                                    return (
                                        <li key={item.index} id={`scroll-element-${item.index}`}>
                                            <div className="title">{item.name}</div>
                                            <div className="box">
                                                <div className="preview-block">
                                                    <div className="window">
                                                        <div
                                                            className={`image${
                                                                item.content._image_canvas_loading ? ' is-loading' : ''
                                                            }`}
                                                            style={{
                                                                backgroundImage: `${
                                                                    item.content.custom_image
                                                                        ? `url(${item.content.image_url})`
                                                                        : `url(${item.content._image_canvas_data})`
                                                                }`,
                                                            }}
                                                        ></div>
                                                        <div className="text">
                                                            <div
                                                                className={`title${
                                                                    !item.content.title.length ? ' title-empty' : ''
                                                                }`}
                                                            >
                                                                {item.content.title}
                                                            </div>
                                                            <div
                                                                className={`description${
                                                                    !item.content.description.length
                                                                        ? ' description-empty'
                                                                        : ''
                                                                }`}
                                                            >
                                                                {item.content.description}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="upload">
                                                        <button
                                                            className="button"
                                                            data-size="md"
                                                            data-variant="primary"
                                                            onClick={this.handleClick__open_asset_manager_modal(
                                                                item.index,
                                                            )}
                                                        >
                                                            {t(
                                                                '_components._modal._share_project_options.change_image',
                                                            )}
                                                        </button>
                                                        {item.content.custom_image ? (
                                                            <p
                                                                onClick={this.handleClick__restore_image(
                                                                    'entities',
                                                                    item.index,
                                                                )}
                                                            >
                                                                {t(
                                                                    '_components._modal._share_project_options.restore_image',
                                                                )}
                                                            </p>
                                                        ) : null}
                                                    </div>
                                                    <div className="note">
                                                        {t(
                                                            '_components._modal._share_project_options.recommended_resolution',
                                                        )}
                                                        <br />
                                                        {t('_components._modal._share_project_options.up_to_10_mb')}
                                                    </div>
                                                </div>
                                                <div className="info-block">
                                                    <ul className="inputs-block">
                                                        <li>
                                                            <div className="title">
                                                                {t('_common.title')}
                                                                <span>{item.content.title.length}/40</span>
                                                            </div>
                                                            <div className="input-box">
                                                                <input
                                                                    autoComplete="off"
                                                                    maxLength={40}
                                                                    type="text"
                                                                    value={item.content.title}
                                                                    onChange={this.handleChange__input(
                                                                        item.index,
                                                                        'title',
                                                                    )}
                                                                />
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="title">
                                                                {t('_common.description')}
                                                                <span>{item.content.description.length}/100</span>
                                                            </div>
                                                            <div className="textarea-box">
                                                                <textarea
                                                                    rows="3"
                                                                    value={item.content.description}
                                                                    maxLength={100}
                                                                    onChange={this.handleChange__input(
                                                                        item.index,
                                                                        'description',
                                                                    )}
                                                                ></textarea>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>

                        <div className="bottom-bar">
                            <div className="left">
                                <div className="icon">
                                    <IconInfo />
                                </div>
                                <p>{t('_components._modal._share_project_options.social_cache')}</p>
                            </div>
                            <div className="right">
                                <button
                                    className="button"
                                    data-variant="secondary"
                                    data-size="lg"
                                    onClick={events.on_close}
                                >
                                    {t('Cancel')}
                                </button>
                                <button
                                    className="button"
                                    data-variant="primary"
                                    data-size="lg"
                                    disabled={saving_process}
                                    onClick={this.handleClick__save}
                                >
                                    {t('_common.save')}
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <AssetManager
                    isOpen={asset_manager_modal.is_open}
                    projectId={project.projectId}
                    onPlaceImage={this.handleClick__place_image}
                    onClose={this.handleClick__close_asset_manager_modal}
                />
            </>
        ) : null
    }
}

export default compose(connect(null, null), withTranslation('translations'))(ShareProjectOptions)
